import React from 'react';

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Types} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Security Center',
		url: '/securities',
		icon: 'shield',
	},
];

export default class Advertisement extends Framework.Components.View {

	submitModule = async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.READ);

		moduleModel.object.module = 3;

		try {
			await moduleModel.submit(null, API.RequestType.CREATE);
		} catch (e) {
		}

		this.setState({loading: false});
		this.props.reloadShell();
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<div className={"row"}>
					<div className={'col-10 offset-1'}>

						<div className="row">
							<div className="col-md-4">
								<span className="text-center"
								      style={{
									      marginTop: '20px',
									      display: 'block',
									      paddingTop: '25px',
									      paddingBottom: '25px'
								      }}><i className="fa fa-shield fa-5x"/></span>
							</div>
							<div className="col-md-8">
								<h3>Security Center</h3>
								<p>Add the Security Center Module to take your security to the next level. With the security center you get Screen
									Lock, Two-Step Authentication, Access Mapping, Whitelist &amp; Banned IP Addresses and detailed Login Records.
									Protect all of your FFLs for a single monthly cost of $5.00.</p>
							</div>
						</div>
						<hr/>
						<div className="row">
							<div className="col-md-8">
								<h3>Screen Lock &amp; Password Complexity</h3>
								<p>With automatic PIN screen locking you can insure your data is protected even if you walk away from your computer.
									For extreme protection you can force all of your users into screen lock or IOI mode by location or across the
									entire account. And by implementing strong password complexity requirements and password expiration you can
									protect your account from human error.</p>
							</div>
							<div className="col-md-4">
								<span className="text-center"
								      style={{
									      display: 'block',
									      paddingTop: '10px',
									      paddingBottom: '10px'
								      }}><img src="/assets/images/security_screen_lock.PNG" width="200" alt={'fflboss'}/></span>
							</div>
						</div>
						<hr/>
						<div className="row">
							<div className="col-md-4">
								<span className="text-center"
								      style={{
									      display: 'block',
									      paddingTop: '10px',
									      paddingBottom: '10px'
								      }}><img src="/assets/images/security_access_map.PNG" width="200" alt={'map'}/></span>
							</div>
							<div className="col-md-8">
								<h3>Access Mapping &amp; Login Records</h3>
								<p>With the security center each login attempt successful or failed is analyzed and logged. A visual map of access
									locations can help you see if anything is amiss at a glance. For more detailed records you can see the time and
									IP addresses the login attempts came from and ban the IP from ever attempting to accessing your account again.</p>
							</div>
						</div>
						<hr/>
						<div className="row">
							<div className="col-md-8">
								<h3>Two-Step Authentication</h3>
								<p>With Two-Step authentication &amp; OneTouch powered by Authy logging in securely is a breeze. And with IP
									Whitelisting you can bypass two-step authentication for your office or home to speed up the process while still
									remaining secure.</p>
							</div>
							<div className="col-md-4">
								<span className="text-center"
								      style={{
									      display: 'block',
									      paddingTop: '30px',
									      paddingBottom: '30px',
									      marginTop: '20px'
								      }}><img src="/assets/images/security_authy.png" width="200" alt={'authy logo'}/></span>
							</div>
						</div>
						<br/>
						<br/>
						<br/>
						<div style={{
							marginTop: '15px',
							backgroundColor: '#eef7ea',
							borderColor: '#bbdba1'
						}}>
							<div className="row">
								<div className="col-md-9">
									<h2>Security Center Module</h2>
									<p>Add the Security Center Module now for $5/mo*.</p>
									{/*{#If you submit at least 5 NFA Reservations per month, the monthly service charge will be waived.  To find out more about the Powered by Silencer Shop integration, <a href="/account#integrations">click here.</a>#}*/}
									<p style={{fontSize: '11px'}}><i>* This is a single $5/mo charge to activate the Security Module on all locations
										and is in addition to your monthly FFL Boss subscription(s).</i></p>
								</div>
								<div className="col-md-3" style={{textAlign: 'right'}}>
									<h2 style={{paddingTop: '15px'}}>$5.00</h2>

									{/*if user vs owner*/}

									{/*<a type="button" className="btn btn-sm btn-warning">*/}
									{/*	<i className="fa fa-lock"/> Must Be Account Owner*/}
									{/*</a>*/}

									{/*else*/}

									<a type="button" data-module="module_security" onClick={this.submitModule}
									   className="create_module btn btn-sm btn-primary">
										<i className="fa fa-tags"/> Add Module
									</a>

									{/*end if*/}

								</div>

							</div>

						</div>

					</div>
				</div>
			</div>
		);
	}
}


